import { Link } from "@mui/material";

export const globalSearch = {
    "documents": {
      "CUSTOMER": [
        {
          "documentType": "CUSTOMER",
          "indexCreated": "2023-07-02T05:43:02.897+00:00",
          "id": 207,
          "name": "Amit Ghildiyal",
          "description": "",
          "email": "ghildiyal.poonam@gmail.com",
          "phone": "862565472",
          "created": "2023-01-27T17:42:30.177+00:00",
          "updated": "2023-01-27T17:42:30.177+00:00"
        },
        {
          "documentType": "CUSTOMER",
          "indexCreated": "2023-07-02T05:43:02.897+00:00",
          "id": 489,
          "name": "Amit Ghildiyal",
          "description": "",
          "email": "ghildiyal.poonam@gmail.com",
          "phone": "862565472",
          "created": "2023-02-18T05:48:09.821+00:00",
          "updated": "2023-02-18T05:48:09.821+00:00"
        },
      ],
      "LEAD": [
        {
            "documentType": "LEAD",
            "indexCreated": "2023-07-02T05:43:02.897+00:00",
            "id": 208,
            "name": "Pankaj Maurya",
            "description": "",
            "email": "pankaj.kr@gmail.com",
            "phone": "862565472",
            "created": "2023-01-27T17:42:30.177+00:00",
            "updated": "2023-01-27T17:42:30.177+00:00"
          
        },
        {
            "documentType": "LEAD",
            "indexCreated": "2023-07-02T05:43:02.897+00:00",
            "id": 211,
            "name": "Raushan Maurya",
            "description": "",
            "email": "raushan.maurya@gmail.com",
            "phone": "862565472",
            "created": "2023-01-27T17:42:30.177+00:00",
            "updated": "2023-01-27T17:42:30.177+00:00"
          
        }
      ],
      "PRODUCT": [
        {
            "documentType": "PRODUCT",
            "indexCreated": "2023-07-02T05:43:02.897+00:00",
            "id": 207,
            "name": "2 BHK",
            "description": "",
            "type": "Resedential",
            "status": "Open",
            "created": "2023-01-27T17:42:30.177+00:00",
            "updated": "2023-01-27T17:42:30.177+00:00"
          
        },
        {
          "documentType": "PRODUCT",
          "indexCreated": "2023-07-02T05:43:02.897+00:00",
          "id": 207,
          "name": "2 BHK",
          "description": "",
          "type": "Insurance",
          "status": "Open",
          "created": "2023-01-27T17:42:30.177+00:00",
          "updated": "2023-01-27T17:42:30.177+00:00"
        
        }
      ],
      "MERCHANT": [
        {
            "documentType": "MERCHANT",
            "indexCreated": "2023-07-02T05:43:02.897+00:00",
            "id": 207,
            "name": "Amit Ghildiyal",
            "description": "",
            "email": "ghildiyal.poonam@gmail.com",
            "phone": "862565472",
            "created": "2023-01-27T17:42:30.177+00:00",
            "updated": "2023-01-27T17:42:30.177+00:00"
          
        },
        {
          "documentType": "MERCHANT",
          "indexCreated": "2023-07-02T05:43:02.897+00:00",
          "id": 207,
          "name": "Amit Ghildiyal",
          "description": "",
          "email": "ghildiyal.poonam@gmail.com",
          "phone": "862565472",
          "created": "2023-01-27T17:42:30.177+00:00",
          "updated": "2023-01-27T17:42:30.177+00:00"
        
        }
      ]
    }
  }

  const handleViewRecord = (cellValues) => {
    console.log("cellValues",cellValues);
  }

  export const globalColumns = {
    "LEAD": [
        { 
            field: 'id', 
            headerName: "Lead Id", 
            flex: 1,
            renderCell: (cellValues) => {
                return  <Link
                component="button"
                variant="body2"
                onClick={() => handleViewRecord(cellValues)}
              >
                {cellValues?.row?.id}
              </Link>
            }
        },
        { 
            field: 'name', 
            headerName: "Name", 
            flex: 1,
        },
        {
            field: 'email',
            headerName: "Email",
            flex: 1,
        },
        {
            field: 'phone',
            headerName: "Phone" ,
            flex: 1,
        },
        {
            field: "found",
            headerName: "Found In",
            flex: 1
        }
        
    ],
    "CUSTOMER": [
        { 
            field: 'id', 
            headerName: "Customer Id", 
            flex: 1,
            renderCell: (cellValues) => {
                return  <Link
                component="button"
                variant="body2"
                onClick={() => handleViewRecord(cellValues)}
              >
                {cellValues?.row?.id}
              </Link>
            }
        },
        { 
            field: 'name', 
            headerName: "Name", 
            flex: 1,
        },
        {
            field: 'email',
            headerName: "Email",
            flex: 1,
        },
        {
            field: 'phone',
            headerName: "Phone" ,
            flex: 1,
        },
        {
            field: "found",
            headerName: "Found In",
            flex: 1
        }
        
    ],
    "PRODUCT": [
        { 
            field: 'id', 
            headerName: "Product Id", 
            flex: 1,
            renderCell: (cellValues) => {
                return  <Link
                component="button"
                variant="body2"
                onClick={() => handleViewRecord(cellValues)}
              >
                {cellValues?.row?.id}
              </Link>
            }
        },
        { 
            field: 'name', 
            headerName: "Name", 
            flex: 1,
        },
        {
            field: 'type',
            headerName: "Type",
            flex: 1,
        },
        {
            field: 'status',
            headerName: "Status",
            flex: 1,
        },
        {
            field: "found",
            headerName: "Found In",
            flex: 1
        }
        
    ],
    "MERCHANT": [
        { 
            field: 'id', 
            headerName: "Merchant Id", 
            flex: 1,
            renderCell: (cellValues) => {
                return  <Link
                component="button"
                variant="body2"
                onClick={() => handleViewRecord(cellValues)}
              >
                {cellValues?.row?.id}
              </Link>
            }
        },
        { 
            field: 'name', 
            headerName: "Name", 
            flex: 1,
        },
        {
            field: 'email',
            headerName: "Email",
            flex: 1,
        },
        {
            field: 'phone',
            headerName: "Phone" ,
            flex: 1,
        },
        {
            field: "found",
            headerName: "Found In",
            flex: 1
        }
    ]
  }

  